import { useCallback } from "react";

import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";
import { useQueryClient } from "react-query";
import offIcon from "src/assets/images/device-type-icons/vacuum-cleaner.svg";

import api from "../../../../../../../../../api/api";
import animation from "../../../../../../../../../assets/animations/vacuum-cleaner.json";
import { useTranslatedStrings } from "../../../../../../../../../hooks/translate";
import DeviceWidgetTitle from "../../device-title";

interface Props {
  device: Device;
}
export default function VacuumCleanerDevice(props: Props) {
  const queryClient = useQueryClient();

  const { device } = props;
  const isOn = device.powerState == "ON";
  const strings = useTranslatedStrings();

  const deviceId = device._id ?? "";
  const backgroundColor = isOn ? "white" : "rgb(51, 51, 51)";

  const onclick = useCallback(async () => {
    const response = await api.apiV4DirectiveDeviceDeviceIdPut(deviceId, {
      source: "web",
      directive: { field: "powerState", value: isOn ? "OFF" : "ON" },
    });
    if (response.status == 200) {
      queryClient.invalidateQueries(["devices", `${deviceId}`]);
    }
  }, [deviceId, isOn, queryClient]);

  return (
    <Box
      sx={{
        padding: "3px",
        backgroundColor,
        height: "100%",
        borderRadius: "5px",
      }}
      onClick={onclick}
    >
      <DeviceWidgetTitle device={device} />

      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box
          sx={{
            paddingLeft: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          {isOn ? (
            <Lottie animationData={animation} style={{ width: 60 }} />
          ) : (
            <img style={{}} src={offIcon} width={"60"} />
          )}
        </Box>
        <Box sx={{ flex: 1 }} />
        <Typography
          variant="h2"
          sx={{ color: "grey", marginRight: "15px", marginTop: "10px" }}
        >
          {isOn ? strings.cleaning : strings.off}
        </Typography>
      </Box>
    </Box>
  );
}
